import React,{useState,useEffect} from 'react';
//import DataTableWarehouseStatusOnDateSum from '../../components/datatable/DataTableWarehouseStatusOnDateSum';
import DataTableWarehouseStatusSum from '../../components/datatable/DataTableWarehouseStatusSum';
import {useTranslation} from 'react-i18next';

import * as RestService from '../../services/eisRest';
import * as moment from 'moment';
import 'moment/locale/sk';




const  WarehouseStatusOnDateDatatable = (props) => {

    const [t] = useTranslation();   
    const [warehouseId, setWarehouseId] = useState('');   
    const [url, setUrl] = useState('');   
    const [urlExcel, setUrlExcel] = useState('');      
 
    const {i18n} = useTranslation();  
  //  const [entityId, setEntityId] = useState();
    const tableName = t('warehouse.label.stockStatus'); 


    const getDate = (value) => {
        //console.log(i18n.language);
        moment.locale(i18n.language);
        let f = "";
        if(value>0){
            f = moment(value).format("DD.MM.YYYY");
        }
        return (<span>{f}</span>);
    }
    
    const columns = [       
        { name: "Id",  selector: "id", omit: true},
        { name: t('article.label.articleName'),  sortable: true, selector: "article\.name", minWidth: '300px'},    		
        { name: t('article.label.articleNumber'),  sortable: true, selector: "article\.nbr"},  
     //   { name: t('article.label.articleNumber'), sortable: true, selector: "article.nbr"},    		       
        { name: t('warehouse.label.qty'),  sortable: true,  selector: "qty"},      
     //   { name: t('article.label.measureUnit'), sortable: true,  selector: "article.measureUnit"},   
        { name: t('warehouse.label.priceExcludeVatAvg'), sortable: true,  selector: "unitPriceExcludeVatAvg"},   
        { name: t('warehouse.label.totalExcludeVatAvg'), sortable: true,  selector: "totalPriceExcludeVatAvg"},   
        { name: t('warehouse.label.transactionFrom'), sortable: true,   selector: d => {
            return getDate(d.dateFrom);
        }},   
        { name: t('warehouse.label.transactionTo'), sortable: true,  selector: d => {
            return getDate(d.dateTo);
        }},   
      
        
      //  { name: t('general.label.description'), sortable: true,  selector: "article.description"},
      //  { name: t('warehouse.label.warehouseName'), sortable: true,  selector: "warehouse.name"},
      //  { name: t('warehouse.label.warehouseNumber'), sortable: true,  selector: "warehouse.number"}
    ];        


    
    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('general.label.name'), data: "article.name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
        { name: t('article.label.articleNumber'), data: "article.nbr", orderable: true,  searchable: true, search: {value: '',regex: false}},       
        { name: t('article.label.measureUnit'), data: "article.measureUnit", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('warehouse.label.qty'), data: "qty", orderable: true,  searchable: true, search: {value: '',regex: false}},          
        { name: t('warehouse.label.priceExcludeVatAvg'), data: "unitPriceExcludeVatAvg", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('warehouse.label.totalExcludeVatAvg'), data: "totalPriceExcludeVatAvg", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('general.label.description'), data: "article.description", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('warehouse.label.warehouseName'), data: "warehouse.name", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('warehouse.label.warehouseNumber'), data: "warehouse.number", orderable: true,  searchable: true, search: {value: '',regex: false}},                 
        { name: t('warehouse.label.transactionFrom'), data: "dateFrom", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('warehouse.label.transactionTo'), data: "dateTo", orderable: true,  searchable: true, search: {value: '',regex: false}},    
       
    ];        

 //   const url = RestService.getBaseURL()+"warehouse/getWarehouseStatusOnDateList?warehouseId="+props.warehouseId;   
  //  const urlExcel = RestService.getBaseURL()+"warehouse/getWarehouseStatusOnDateListExcel?warehouseId="+props.warehouseId;          
    
    useEffect(() => {
        setWarehouseId(props.warehouseId);
        setUrl(RestService.getBaseURL()+"warehouse/getWarehouseStatusOnDateList?warehouseId="+props.warehouseId);
        setUrlExcel(RestService.getBaseURL()+"warehouse/getWarehouseStatusOnDateListExcel?warehouseId="+props.warehouseId);
     }, [props.warehouseId]);

 


     const handleCallback  = (id) => {
                     
     };
   
          
    
         return (
           
             <DataTableWarehouseStatusSum //DataTableWarehouseStatusOnDateSum
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={true}                 
                 warehouseId={warehouseId}                 

             />
           
         );
    
 
  
 };

export default WarehouseStatusOnDateDatatable;

